import StageTime from './styled';

export default StageTime;
